/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import clsx from 'clsx';

import { useStyles } from './styles';

/**
 * @typedef {Object} FileSelectorButtonProps
 * @property {*} [children]
 * @property {string} [className]
 * @property {boolean} [multiple]
 * @property {Boolean} disabled
 * @property {Function} onFileChange
 */

const acceptFiles = [
  'image/png',
  'image/jpg',
  'image/jpeg',
  '.pdf',
  '.docx',
  '.doc',
  '.pptx',
  '.ppt',
  '.xlsx',
  '.xls',
  '.csv',
  '.zip'
];
const strFilesAccepted = acceptFiles.join(',');

/**
 * @param {FileSelectorButtonProps} props
 */
const FileSelectorButton = props => {
  const { className, children, multiple, disabled, onFileChange } = props;
  const classes = useStyles();
  return (
    <div className={clsx(classes.root, className)}>
      <input
        id="contained-button-file"
        className={classes.input}
        type="file"
        disabled={disabled}
        multiple={multiple}
        accept={strFilesAccepted}
        onChange={onFileChange}
      />
      <label htmlFor="contained-button-file" className={classes.label}>
        {children}
      </label>
    </div>
  );
};

FileSelectorButton.defaultProps = {
  children: undefined,
  className: null,
  multiple: false,
  disabled: false
};

export default FileSelectorButton;
